export const Worker = {
    path: '/workers',
    name: 'workers',
    component: () => import('@/views/Worker/WorkerPage.vue'),
    children: [
        {
            path: '/workers/add',
            name: 'workers.add',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/workers/edit/:id',
            name: 'workers.edit',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {updateAction: true},
            children: [
                {
                    path: '/workers/edit/request/view/:id',
                    name: 'workers.edit.request.view',
                    component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/workers/edit/pay_slip/view/:id',
                    name: 'workers.edit.pay_slip.view',
                    component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
                },
            ]
        },
        {
            path: '/workers/delete/:id',
            name: 'workers.delete',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {deleteAction: true},
            children: [
                {
                    path: '/workers/delete/request/view/:id',
                    name: 'workers.delete.request.view',
                    component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/workers/delete/pay_slip/view/:id',
                    name: 'workers.delete.pay_slip.view',
                    component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
                },
            ]
        },
        {
            path: '/workers/view/:id',
            name: 'workers.view',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {viewAction: true},
            children: [
                {
                    path: '/workers/view/request/view/:id',
                    name: 'workers.view.request.view',
                    component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/workers/view/pay_slip/view/:id',
                    name: 'workers.view.pay_slip.view',
                    component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
                },
            ]
        },
        {
            path: '/workers/deactivate/:id',
            name: 'workers.deactivate',
            component: () => import('@/views/Worker/Form/DeactivateForm.vue'),
        },
        {
            path: '/workers/ats/:id',
            name: 'workers.ats',
            component: () => import('@/views/Worker/Form/ATSForm.vue'),
        },
        {
            path: '/workers/set_data_access',
            name: 'workers.set_data_access',
            component: () => import('@/views/Worker/Form/SetDataAccessForm.vue'),
        },
        {
            path: '/workers/add_pay_sections',
            name: 'workers.add_pay_sections',
            component: () => import('@/views/Worker/Form/PaySectionsManage.vue'),
            props: {addAction: true}
        },
        {
            path: '/workers/delete_pay_sections',
            name: 'workers.delete_pay_sections',
            component: () => import('@/views/Worker/Form/PaySectionsManage.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/workers/documents/:id',
            name: 'workers.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "WORKER"}
        },
        {
            path: '/workers/template_applications/:id',
            name: 'workers.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "WORKER"}
        },
    ]
}

export const WorkerConfiguration = {
    path: '/workers_configuration',
    name: 'workers_configuration',
    component: () => import('@/views/Worker/Form/WorkerConfiguration.vue'),
}